var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1345 21.9969C11.9492 22.129 11.7273 22.2001 11.4998 22.2001C11.2722 22.2001 11.0503 22.129 10.8651 21.9969C5.39223 18.0959 -0.416128 10.0719 5.45569 4.27373C7.06714 2.68719 9.23839 1.79881 11.4998 1.80078C13.7665 1.80078 15.9413 2.69045 17.5439 4.27259C23.4157 10.0707 17.6073 18.0936 12.1345 21.9969Z",
    stroke: "#35d169",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 12.0001C12.1012 12.0001 12.6778 11.7613 13.1029 11.3363C13.5279 10.9112 13.7667 10.3346 13.7667 9.73347C13.7667 9.13231 13.5279 8.55577 13.1029 8.13069C12.6778 7.70561 12.1012 7.4668 11.5001 7.4668C10.8989 7.4668 10.3224 7.70561 9.89729 8.13069C9.47221 8.55577 9.2334 9.13231 9.2334 9.73347C9.2334 10.3346 9.47221 10.9112 9.89729 11.3363C10.3224 11.7613 10.8989 12.0001 11.5001 12.0001Z",
    stroke: "#35d169",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreet);
export default __webpack_public_path__ + "static/media/street.d103732f2f3c218c95d46e7b933d182b.svg";
export { ForwardRef as ReactComponent };